import { useMutation, useQuery } from '@tanstack/react-query';
import { IDictionaryEntry } from '../../Interfaces/IDictionaryEntry';
import { customFetcher } from '../useFetch';
import { IDictionary } from '../../Interfaces/IDictionary';

export const useGetDictionaryEntries = () => {
  const {
    data: dictionaryEntries,
    isLoading: isLoadingDictionaryEntries,
    refetch: refetchDictionaryEntries,
  } = useQuery<IDictionaryEntry[]>({
    queryKey: ['dictionaryentry'],
    queryFn: () => customFetcher({ endpoint: '/dictionaryentry' }),
  });

  return {
    dictionaryEntries,
    isLoadingDictionaryEntries,
    refetchDictionaryEntries,
  };
};

export const useWriteDictionaryEntry = () => {
  const {
    mutateAsync: writeDictionaryEntry,
    isPending: isPendingDictionaryEntry,
  } = useMutation({
    mutationFn: (uploadObject: IDictionaryEntry) =>
      customFetcher({
        endpoint: '/dictionaryentry',
        body: uploadObject,
        method: uploadObject.idDictionaryEntry < 0 ? 'POST' : 'PUT',
      }),
  });
  return {
    writeDictionaryEntry,
    isPendingDictionaryEntry,
  };
};

export const useDeleteDictionaryEntry = () => {
  const {
    mutateAsync: deleteDictionaryEntry,
    isPending: isPendingDeleteDictionaryEntry,
  } = useMutation({
    mutationFn: (idObject: number) =>
      customFetcher({
        endpoint: `/dictionaryentry/${idObject}`,
        method: 'DELETE',
      }),
  });
  return {
    deleteDictionaryEntry,
    isPendingDeleteDictionaryEntry,
  };
};
